import type { PlanCode, PrototypeRuntime } from "./prototypeTypes";
import type { ClientPlanContext } from './clientPlanContext';

export type PrototypeState = {
  runtime: PrototypeRuntime;
  isLoggedIn: boolean;
  currentPlan: PlanCode;
  effectiveAccessPlan: PlanCode;
  planContext: ClientPlanContext | null;
};

export function isPaidPlan(plan: PlanCode) {
  return plan === "lite" || plan === "pro" || plan === "max";
}
